import "@/shared/styles/index.scss";
import "@/lib/sentry";
import "@/lib/mixpanel-client";
import { capturePaddleCoupon } from "@/shared/utils/capture-paddle-coupon";

import type { Auth } from "firebase/auth";
import type mixpanel from "mixpanel-browser";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import {
  AuthProvider,
  ReactQueryProvider,
  StoreProvider,
} from "@/core/providers";
import { router } from "@/core/routes";

window.BUNDLE_VERSION = "5.0.0";

capturePaddleCoupon();

declare global {
  interface Window {
    Swiper: unknown;
    BUNDLE_VERSION: string;
    hj: (event: string, data: unknown) => void;
    Intercom: (command: string, message?: string | undefined | object) => void;

    // ==== wizard related window variables ====
    mixpanel: typeof mixpanel;
    firebase: {
      auth: () => Auth;
    };
  }
}

createRoot(document.getElementById("root") as HTMLElement).render(
  <StoreProvider>
    <ReactQueryProvider>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </ReactQueryProvider>
  </StoreProvider>,
);
